import axios from "axios";
import { BACKEND_URL } from "../utils/api";

export interface DashboardStats {
  paiment: {
    total_payments: number;
    total_success_payments: number;
    total_error_payments: number;
    total_pending_payments: number;
    percentage_of_success_payments: number;
  };
  users: {
    total_users: number;
    totals_verified_users: number;
    totals_unverified_users: number;
    totals_active_users: number;
    totals_inactive_users: number;
    totals_pending_kyc_users: number;
    totals_rejected_kyc_users: number;
    totals_users_withouth_kyc: number;
    total_kyc_validated: number;
  };
  country: {
    total_country: number;
    total_country_transfert: number;
  };
  finance: {
    revenu_total_cad: number;
    revenu_total_fcfa_cmr: number;
  };
  dayly_finance: {
    total_success_payment_today: number;
    total_error_payment_today: number;
  };
  top_operators: Array<{
    operator: string;
    transaction_count: number;
    total_amount_cad: number;
  }>;
}

export const dashbordStatsService = {
  getStats: async (token: string): Promise<DashboardStats> => {
    try {
      const response = await axios.get(`${BACKEND_URL}/dashboard/stats`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // On renvoie UNIQUEMENT les stats
      return response.data.data;
    } catch (error: any) {
      // Gestion propre des erreurs Axios
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message || "Erreur lors de la récupération des statistiques";

        throw new Error(message);
      }

      throw new Error("Erreur inconnue");
    }
  },
};
